import styled from 'styled-components';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';


export const PriceInfoContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 8px;
  flex: 1;
  width: 100%;

   @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PriceDisplayContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-top: 8px;
  width: 100%;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    text-align: right;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PriceFreightContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
